import {
  List, Datagrid, TextField, DateField, EditButton, Edit, Create, SimpleForm,
  TextInput, SelectInput, DateInput, TextInput as RaTextInput, required,
} from 'react-admin';
import { Stack } from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { ImageUploadInput } from '../../components/ImageUploadInput.jsx';

const CATEGORIES = [
  { id: 'academic', name: 'Academic' },
  { id: 'sport', name: 'Sport' },
  { id: 'art', name: 'Art' },
  { id: 'science', name: 'Science' },
];

const filters = [
  <RaTextInput key="q" source="q" label="Search" alwaysOn />,
  <SelectInput key="category" source="category" choices={CATEGORIES} alwaysOn />,
];

const AchievementList = () => (
  <List sort={{ field: 'achievedOn', order: 'DESC' }} filters={filters} perPage={25}>
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="title" />
      <TextField source="category" />
      <TextField source="recipient" />
      <DateField source="achievedOn" label="Achieved on" />
      <EditButton />
    </Datagrid>
  </List>
);

const AchievementForm = () => (
  <Stack spacing={2} sx={{ maxWidth: 800 }}>
    <TextInput source="title" validate={required()} fullWidth />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <SelectInput source="category" choices={CATEGORIES} validate={required()} sx={{ minWidth: 200 }} />
      <DateInput source="achievedOn" label="Achieved on" />
      <TextInput source="recipient" label="Recipient (optional)" fullWidth />
    </Stack>
    <TextInput source="description" multiline minRows={4} fullWidth />
    <ImageUploadInput source="image" label="Photo / certificate" />
  </Stack>
);

const AchievementEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm><AchievementForm /></SimpleForm>
  </Edit>
);
const AchievementCreate = () => (
  <Create redirect="list">
    <SimpleForm><AchievementForm /></SimpleForm>
  </Create>
);

export default {
  list: AchievementList,
  edit: AchievementEdit,
  create: AchievementCreate,
  icon: EmojiEventsIcon,
  options: { label: 'Achievements' },
  recordRepresentation: 'title',
};
